// Index barrel exports
export { FORMATION_META, SEQUENCES, findSequenceBySlug } from './referentiel';
export { sequence1 } from './sequence1';
export { sequence2 } from './sequence2';
export { sequence3 } from './sequence3';
export { sequence4 } from './sequence4';
export { sequence5 } from './sequence5';

import { sequence1 } from './sequence1';
import { sequence2 } from './sequence2';
import { sequence3 } from './sequence3';
import { sequence4 } from './sequence4';
import { sequence5 } from './sequence5';

export const SEQUENCES_DATA = {
  'representations':     sequence1,
  'hors-circulation':    sequence2,
  'code':                sequence3,
  'circulation':         sequence4,
  'sensibilisation':     sequence5,
};
